import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=c5b68aba&scoped=true"
import script from "./thirdLogin.vue?vue&type=script&lang=js"
export * from "./thirdLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_658dcddb1d89a08c03476f5e8f9c1110/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b68aba",
  null
  
)

export default component.exports